import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUblockoriginComponent } from './simple-icons-ublockorigin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUblockoriginComponent ],
    exports:      [ SimpleIconsUblockoriginComponent ],
    bootstrap:    []
})
export class SimpleIconsUblockoriginModule {}
